/* eslint-disable import/prefer-default-export,react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isIOS, isMobile } from 'react-device-detect';
import Input from '../../../../components/Input';
import { getMaskedPhoneNumber } from '../../../../utilities/helpers';
import { SecurityTOTPBodyLayout } from '../partials';

export const ResetTFAComponent = ({
  form,
  state,
  handleSubmit,
  setCheckByVerifyResetOtp,
  handleRequestPhoneNumberVerification,
  renderButtons,
  handleChange,
  timer,
  isCheckingTOTPLoading,
  isLoadingResetOtp,
  isLoadingRequestPhoneVerification,
}) => {
  const { t: translate } = useTranslation();

  return (
    <SecurityTOTPBodyLayout title={translate('2TFA_page_title')} renderButtons={renderButtons}>
      <form onSubmit={handleSubmit} id="confirm-phone-form">
        <Input
          subLabel={`${translate('confirm_phone_number_message_label_nosec').replace(
            '%s',
            getMaskedPhoneNumber(form?.confirmed_phone_number, state?.country_code)
          )} ${timer} ${translate('email_verification_subtext_label_sec')}`}
          value={form.code}
          name="code"
          type="number"
          onChange={handleChange}
          actionLabel={translate('resend_button_label')}
          actionClick={() => {
            setCheckByVerifyResetOtp(false);
            handleRequestPhoneNumberVerification();
          }}
          actionDisabled={
            isCheckingTOTPLoading ||
            isLoadingResetOtp ||
            isLoadingRequestPhoneVerification ||
            timer > 0
          }
          className={`${isMobile ? 'text-f6' : ''} ${isIOS ? 'ios' : ''}`}
          placeholder={translate('whitelist_verify_code_phone_number')}
          label={translate('whitelist_verify_code_phone_number')}
          groupClassName={`mb-0 mt-4 ${isIOS ? 'ios' : ''}`}
          autoComplete="off"
          actionBtnTop="18%"
          withFloatingLabel
          withSubLabel
        />
      </form>
    </SecurityTOTPBodyLayout>
  );
};

ResetTFAComponent.propTypes = {
  form: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleRequestPhoneNumberVerification: PropTypes.func.isRequired,
  setCheckByVerifyResetOtp: PropTypes.func.isRequired,
  renderButtons: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  timer: PropTypes.number.isRequired,
  isCheckingTOTPLoading: PropTypes.bool.isRequired,
  isLoadingResetOtp: PropTypes.bool.isRequired,
  isLoadingRequestPhoneVerification: PropTypes.bool.isRequired,
};
